<template>
  <div class="tip primary grid">
    <div class="col" v-for="(item, index) in source" :key="index">
      <template v-if="index == 0">
        <div>
          <div>
            <el-tag size="mini" :effect="span == null ? 'dark' : 'plain'" @click="loadStates()"> 全部 </el-tag>
            <el-tag size="mini" :effect="span == 1 ? 'dark' : 'plain'" @click="loadStates(1)"> 今天 </el-tag>
            <el-tag size="mini" :effect="span == 7 ? 'dark' : 'plain'" @click="loadStates(7)"> 近7天 </el-tag>
            <el-tag size="mini" :effect="span == 30 ? 'dark' : 'plain'" @click="loadStates(30)"> 近30天 </el-tag>
          </div>
          <p style="margin-top: 10px">
            <label class="text-xl text-bold">{{ item.value }}</label>
            <label>单</label>
          </p>
        </div>
      </template>
      <template v-else>
        <label class="text-info text-sm" style="margin-top: 5px">{{ item.text }}</label>
        <p>
          <label class="text-xl text-bold">{{ item.value }}</label>
          单
        </p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      source: null
    }
  },
  created () {
    this.loadStates(this.span)
  },
  methods: {
    loadStates (span) {
      this.$apis.mall.order.statis.state({ datespan: span }).then((res) => {
        this.source = [
          {
            text: '全部',
            value: res.reduce((prev, cur) => {
              return prev + cur.value
            }, 0)
          },
          ...res
        ]
        this.span = span
      }).catch((e) => {
        this.$message.error(e)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  grid-gap: 16px;
  line-height: 1;

  div.col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:first-child {
      grid-column-start: span 2;
    }
  }

  .el-tag {
    cursor: pointer;
  }
}
</style>